import { collection, onSnapshot } from 'firebase/firestore';
import React, { act, useEffect, useState } from 'react';
import { db } from '../firebase';

export default function Team({isToogle}) {

    const [personel, setPersonel] = useState([])

      useEffect(() => {
        const getPersonel = onSnapshot(collection(db, "personel"), (snapshot) => {
          setPersonel(snapshot.docs.map((doc) => (doc.data())));
        });
      }, []);

      return (
        <div className={isToogle ? "side-toogle-margin" : "side-margin"} style={{display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column", minHeight: "100vh", overflowY: "scroll", gap: "15px", paddingTop: "20px", paddingBottom: "20px"}}>
            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", gap: "20px"}}>
                {personel?.map((x) => 
                    <h3>{x?.name}</h3>
                )}
            </div>
        </div>
      )

  }